const Footer = () => {
    return (
        <section
            id="footer"
            data-nav-tooltip="Footer"
            className="pp-section"
        >

            <div className="footer text-center">
                <p>
                    © 2024 Hecho con ❤️ por Frank Islas. <br></br> Todos los derechos reservados.
                </p>
            </div>

        </section>
    );
};
export default Footer;
